export const getDomain = (email: string) => {
  const s = email.split('@');
  return s[s.length - 1].toLowerCase();
};
